module.exports = __webpack_public_path__ + "static/media/aggregate_sl_active.5f39ffa1.png";